module.exports = __webpack_public_path__ + "static/media/TableScratch3_Before.e4fa2888.jpg";